export default "__VITE_ASSET__mF40O8Eu__"